/****************************************************
 * Module Name:  viewImageModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import logo from '../../../images/pansuriya.jpg'
import "./../../../style/modalstyle.css";
import Constants from "../../../utility/constants";
import CommonSnackbar from "../../common/commonSnackBar";
import TenderLotProxy from "../../../utility/proxy/manager/tender/tenderLotProxy";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/dist/styles.css";
import "yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css";
import Thumbnails from "yet-another-react-lightbox/dist/plugins/thumbnails";
import Inline from "yet-another-react-lightbox/dist/plugins/inline";
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/dist/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom";

const ViewImageModal = ({ tenderstoneid, handleClose, show }) => {

    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [images, setImages] = useState([]);
    const [loader, setLoader] = useState(true);

    const inline = {
        style: {
            width: "100%",
            maxWidth: "900px",
            aspectRatio: "3 / 2",
            margin: "0 auto",
        },
    };

    useEffect(() => {
        getImagesByStoneId();
    }, []);

    const getImagesByStoneId = () => {
        setLoader(true);

        TenderLotProxy.GetImagesByStoneId(tenderstoneid, (response) => {
            if (response) {
                setLoader(false);
                let transformedData = response.map(item => ({
                    src: item.original
                }));
                setImages(transformedData);
            }
            else {
                setLoader(false);
            }
        })
    }

    return (
        <>
            <CommonSnackbar
                show={showSuccessSnackbar}
                message={"Link Copied Successfully"}
                variant={"success"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Success"}
                handleClose={() => setShowSuccessSnackbar(false)}
            />

            <Modal show={show} onHide={handleClose} enforceFocus={true} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Tender Stone {tenderstoneid} &nbsp;
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box>
                        {loader ?
                            (<Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: "500px"
                                }}
                            >
                                <CircularProgress size={80} />
                            </Box>)
                            : images.length > 0 ? (
                                <Lightbox
                                    slides={images}
                                    inline={inline}
                                    plugins={[Inline, Fullscreen, Slideshow, Thumbnails, Zoom]}
                                    open={show}
                                    close={() => handleClose()}
                                />
                            ) :
                                <Box style={{ height: "500px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ textAlign: "center", color: "black" }}>
                                        <p>No images available.</p>
                                    </div>
                                </Box>
                        }
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default ViewImageModal;
